<script setup lang="ts">
import { Dialog } from "../../../../base-components/Headless";
import { FormLabel, FormInput } from "../../../../base-components/Form";
import Button from "../../../../base-components/Button";
import { ref } from "vue";
import LoadingIcon from "../../../../base-components/LoadingIcon";
// import { Usuario } from "@fixeduy/fixedtypes";

interface Props {
  usuario: any;
}

const props = defineProps<Props>();
const sendButtonRef = ref(null);
const cargando = ref(false);

const emit = defineEmits<{
  (e: "cerrar"): void;
}>();
</script>

<template>
  <Dialog
    :open="true"
    @close="
      () => {
        emit('cerrar');
      }
    "
    :initialFocus="sendButtonRef"
  >
    <Dialog.Panel>
      <Dialog.Title>
        <h2 class="mr-auto text-base font-medium">Información ampliada</h2>
      </Dialog.Title>
      <!-------------------- DIALOG DESCRIPTION ------------------------>

      <Dialog.Description>
        <!-------------------- nombre ------------------------>
        <div class="flex">
          <div class="flex-none w-50 pr-5 mt-2">
            <FormLabel htmlFor="horizontal-form-1 ml-1"> Nombre</FormLabel>
          </div>
          <div class="flex-1 ml-2">
            <FormInput
              type="text"
              disabled="true"
              v-model.trim="props.usuario.nombre"
            />
          </div>
        </div>
      </Dialog.Description>

      <!-------------------- DIALOG FOOTER ------------------------>
      <Dialog.Footer>
        <div v-if="cargando">
          <div
            class="flex flex-col items-rigth justify-end col-span-6 sm:col-span-3 xl:col-span-2"
          >
            <LoadingIcon icon="oval" class="w-8 h-8" />
          </div>
        </div>
        <div v-else>
          <Button
            variant="secondary"
            class="mb-2 mr-3"
            @click="
              () => {
                emit('cerrar');
              }
            "
          >
            Cerrar</Button
          >
        </div>
      </Dialog.Footer>
    </Dialog.Panel>
  </Dialog>
</template>
